import { Link } from 'react-router-dom';

import Chevron from '~/assets/icons/new/chevron-left.svg?react';
import useStyles from '~/common/components/BackToHomeLink/BackToHomeLink.styles';
import TranslatedLabel from '~/common/components/TranslatedLabel/TranslatedLabel';

type BackToHomeLinkProps = {
  /** Destination selected for the current user's role. */
  to: string;
  /** Optional parent-specific layout class. */
  className?: string;
  /** Optional identifier used by parent component tests. */
  testId?: string;
};

/**
 * Renders the shared role-aware back-to-home navigation link.
 */
export const BackToHomeLink = ({
  to,
  className,
  testId,
}: BackToHomeLinkProps): JSX.Element => {
  const { classes, cx } = useStyles();

  return (
    <Link to={to} className={cx(classes.root, className)} data-testid={testId}>
      <Chevron />
      <TranslatedLabel
        typographyVariant="caption_medium"
        translationKey="common:backToHomePage"
      />
    </Link>
  );
};
